import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTemplateArchiveFailedAction = {
	type: 'DOCUMENT_TEMPLATE_ARCHIVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTemplateArchiveFailedAction => ({
	type: 'DOCUMENT_TEMPLATE_ARCHIVE_FAILED',
	payload,
});
